import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  verify: () => api.get('/auth/verify'),
};

// Servers API
export const serversAPI = {
  getAll: () => api.get('/servers'),
  getById: (id) => api.get(`/servers/${id}`),
  create: (data) => api.post('/servers', data),
  start: (id) => api.post(`/servers/${id}/start`),
  stop: (id) => api.post(`/servers/${id}/stop`),
  restart: (id) => api.post(`/servers/${id}/restart`),
  getLogs: (id, tail = 100) => api.get(`/servers/${id}/logs`, { params: { tail } }),
};

// Users API
export const usersAPI = {
  getMe: () => api.get('/users/me'),
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  updateEmail: (email) => api.patch('/users/me/email', { email }),
  updatePassword: (currentPassword, newPassword) => 
    api.patch('/users/me/password', { currentPassword, newPassword }),
};

// Permissions API
export const permissionsAPI = {
  grant: (userId, serverId, canStart, canStop) => 
    api.post('/permissions', { user_id: userId, server_id: serverId, can_start: canStart, can_stop: canStop }),
};

// Activity API
export const activityAPI = {
  getRecent: (limit = 50) => api.get('/activity', { params: { limit } }),
};

// Docker API
export const dockerAPI = {
  listContainers: () => api.get('/docker/containers'),
};

export default api;
